import { EFinancingProgram, EPaymentPlan, EProgressionStatus, EWorksheetDecision } from '@if/core/types'
import { DocumentRequired } from './DocumentSchema'

export const CREDIT_DASHBOARD_FILTER_ALL = 'all' as const
export type CreditDashboardFilterAll = typeof CREDIT_DASHBOARD_FILTER_ALL

export interface CreditDashboardEntry {
  id: string
  createdOn: Date
  clientName: string
  merchantName: string
  merchantId: string
  creditApplicationReferenceNumber: number
  financingProgramId: EFinancingProgram
  progressionStatus: EProgressionStatus
  interestRate: number
  plan: string
  amountRequested: number
  requestedLoanAmount: number
  totalAmountFinanced: number
  maxAmountFinanced: number
  cvtNumber: number
  creditApplicationStatus: string
  worksheetDecision: EWorksheetDecision
  hasDocumentsPendingReview: boolean
  incomeConfirmed: boolean
  missingRequiredDocuments: DocumentRequired[]
  reservedByUserId: string
  reservedByUserName: string
  reservedUntil: Date
  paymentPlanId: EPaymentPlan
  tags?: string[]
  loanPurpose: string | null
  merchantReferenceCode: string | null
}

export interface CreditDashboardFilters {
  financingProgramIds: string[]
  loanPurposeIds: string[]
  team: string
  progressionStatus: string[]
  territoryIds: string[]
  financingCompanyId: string
  plan: string[]
  dateRange: string
  creditApplicationStatus: string
  searchTerm: string
  merchantId: string
  tag: string | null
  minAmountRequested: string
  originSystemIds: string[]
  limit: number
  offset: number
}
